import type { TranslocoService } from '@jsverse/transloco';
import type { TagData } from '@shared/components/table/table.model';

/** Statuses with a translation under orders.paymentStatus.* / orders.providerStatus.* */
const PAYMENT_STATUSES = new Set([
	'PENDING',
	'PENDING_PAYMENT',
	'PENDING_VERIFICATION',
	'COMPLETED',
	'CANCELLED_BY_USER',
	'CANCELLED_BY_ADMIN',
	'REJECTED_BY_STRIPE',
	'EXPIRED',
	'TESTING',
]);

const PROVIDER_STATUSES = new Set([
	'PENDING',
	'SENDING',
	'IN_PROGRESS',
	'WAITING_FUNDS',
	'WAITING_LINK',
	'COMPLETED',
	'PARTIAL',
	'CANCELLED',
	'REFUNDED',
	'FAILED',
	'TESTING',
]);

export const PAYMENT_STATUS_COLORS: Record<string, TagData['color']> = {
	PENDING: 'gray',
	PENDING_PAYMENT: 'gray',
	PENDING_VERIFICATION: 'yellow',
	COMPLETED: 'green',
	CANCELLED_BY_USER: 'red',
	CANCELLED_BY_ADMIN: 'red',
	REJECTED_BY_STRIPE: 'red',
	EXPIRED: 'red',
	TESTING: 'blue',
};

export const PROVIDER_STATUS_COLORS: Record<string, TagData['color']> = {
	PENDING: 'gray',
	SENDING: 'blue',
	IN_PROGRESS: 'blue',
	WAITING_FUNDS: 'yellow',
	WAITING_LINK: 'yellow',
	COMPLETED: 'green',
	PARTIAL: 'yellow',
	CANCELLED: 'red',
	REFUNDED: 'yellow',
	FAILED: 'red',
	TESTING: 'blue',
};

export function paymentStatusTag(status: string, transloco: TranslocoService): TagData {
	const label = PAYMENT_STATUSES.has(status) ? transloco.translate(`orders.paymentStatus.${status}`) : status;
	return { label, color: PAYMENT_STATUS_COLORS[status] || 'gray' };
}

export function providerStatusTag(status: string, transloco: TranslocoService): TagData {
	const label = PROVIDER_STATUSES.has(status) ? transloco.translate(`orders.providerStatus.${status}`) : status;
	return { label, color: PROVIDER_STATUS_COLORS[status] || 'gray' };
}
